import moment from 'moment';
import { CurrencyRate, CURRENCY_EXCHANGE_FIELDS } from 'constant';

export const copyEntry = (entry, items = {}) => {
  const clone = {
    ...entry,
    records: entry.records.map((record) => {
      const item = items[record.item_id];
      const units = new Set();
      const newRecord = { ...record };

      if (item) {
        // const units = [];
        if (item.item_unit_id) {
          units.add(item.item_unit_id);
        }

        item.exchange_units && item.exchange_units.forEach((unit) => {
          units.add(unit.exchange_unit_id);
        });

        newRecord.item_category = item.item_category;
        newRecord.via_import = item.via_import;
        newRecord.enable_excise_tax = item.enable_excise_tax;
        newRecord.enable_other_tax = item.enable_other_tax;
      }

      if (record.item_unit_id) {
        units.add(record.item_unit_id);
      }

      // Exchange unit
      if (newRecord.origin_unit_id && newRecord.origin_unit_id !== newRecord.item_unit_id && newRecord.unit_rate) {
        newRecord.item_unit_id = newRecord.origin_unit_id;
        newRecord.quantity = Math.round(newRecord.quantity * newRecord.unit_rate * 10000) / 10000;
        newRecord.price = Math.round(newRecord.price / newRecord.unit_rate * 10000) / 10000;

        units.add(newRecord.origin_unit_id);
      }

      newRecord.units = Array.from(units);

      return newRecord;
    }),
  };

  if (clone.currency) {
    const rate = clone.currency_rate || CurrencyRate[clone.currency];
    const fields = entry.customer_id ? CURRENCY_EXCHANGE_FIELDS.sale : CURRENCY_EXCHANGE_FIELDS.purchase;
    clone.records.forEach((r) => {
      fields.forEach((field) => {
        if (r[field]) r[field] /= rate;
      });
    });
    // if (clone.currency_rate_type === CurrencyRateType.DEFAULT) clone.currency_rate = null;
  }
  return clone;
};

export const isDict = obj => typeof obj === 'object' && obj !== null && !(obj instanceof Array) && !(obj instanceof Date) && !(obj instanceof FormData);

export const isArray = obj => obj instanceof Array;

export const removeAccent = (input) => {
  if (!input) return input;

  let str = input.toLowerCase();
  str = str.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, 'a');
  str = str.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, 'e');
  str = str.replace(/ì|í|ị|ỉ|ĩ/g, 'i');
  str = str.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, 'o');
  str = str.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, 'u');
  str = str.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, 'y');
  str = str.replace(/đ/g, 'd');

  return str;
};

export const normalizeText = (input) => {
  const output = removeAccent(input).replace(/[^a-z0-9\s]/g, '').replace(/\s\s/g, ' ');
  return output;
};

export const isEmptyObj = (obj) => {
  if (!obj) return true;
  return !Object.keys(obj).some(key => !!obj[key]);
};

export const splitArray = (array, cond) => {
  const match = [];
  const notMatch = [];
  array.forEach((item) => {
    if (cond(item)) {
      match.push(item);
    } else {
      notMatch.push(item);
    }
  });
  return { match, notMatch };
};

export const orderArray = (array, cond) => {
  const { match, notMatch } = splitArray(array, cond);
  return [...match, ...notMatch];
};

export const addToArray = (array, cond, ...newItem) => {
  let index = array.findIndex(cond);
  if (index === -1) index = array.length; // add to end of array
  array.splice(index, 0, ...newItem);
  return array;
};

export const getParentNodes = (currentId, nodes) => {
  if (!currentId) return [];

  let item = nodes[currentId];
  if (!item) return [];

  const parents = [item];
  while (item.parent) {
    item = nodes[item.parent];
    if (!item) break;
    // Avoid loop
    if (parents.find(o => o.id === item.id)) break;
    parents.unshift(item);
  }
  return parents;
};

export const arrayToDict = (array, key = 'id') => {
  if (!array) return {};
  const result = {};
  array.forEach((item) => {
    result[item[key]] = item;
  });
  return result;
};

export const findDuplicate = (items) => {
  const sorted = items.slice().sort();
  const results = [];
  for (let i = 0; i < sorted.length - 1; i += 1) {
    if (sorted[i + 1] === sorted[i]) {
      results.push(sorted[i]);
    }
  }

  return results;
};

export const getAttr = (obj, attr) => {
  if (!obj) return null;
  if (typeof (attr) === 'function') return attr(obj);

  const i = attr.indexOf('.');
  if (i === -1) return obj[attr];

  const firstAttr = attr.substr(0, i);
  const lastAttr = attr.substr(i + 1);
  return getAttr(obj[firstAttr], lastAttr);
};

export const sumTotal = (array, attrs) => {
  const total = {};
  if (!array || array.length === 0) return total;

  array.forEach((item) => {
    attrs.forEach((attr) => {
      if (total[attr] === undefined) total[attr] = 0;
      total[attr] += (getAttr(item, attr) || 0);
    });
  });

  return total;
};

export const getCurrentQuarter = () => {
  const now = new Date();
  const quarter = Math.ceil((now.getMonth() + 1) / 3);
  const beginQuarter = moment([now.getFullYear(), quarter * 3 - 3, 1]);

  return {
    from: beginQuarter,
    to: moment(beginQuarter).add(3, 'months').add(-1, 'days'),
  };
};

export const isEqual = (src, dst, attrs) => {
  if (!attrs) attrs = Object.keys(src);
  console.log('isEqual', src, dst, attrs);
  // eslint-disable-next-line eqeqeq
  return !attrs.some(attr => src[attr] != dst[attr]);
};

export const isNumber = (input) => {
  if (typeof (input) === 'number') return true;

  if (typeof (input) === 'string') {
    if (!input.trim()) return false;
    return !Number.isNaN(Number(input));
  }

  return false;
};



// WEBPACK FOOTER //
// ./src/utils/misc.js